export class Language {
    public static KOREAN: string = "ko";
    public static ENGLISH: string = "en";
}